import { Dimensions, Platform, StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  titleStyle: theme => ({
    fontSize: 25,
    lineHeight: 31.2,
    fontFamily: Fonts.type.VodafoneLt,
    color: theme.colors.textColorThree,
    marginTop: 17.7,
    marginBottom: 21.7,
  }),
  textContainer: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.fillColor,
    marginBottom: 33,
    marginHorizontal: 16,
  }),
  containerViewStyle: isLastItem => ({
    flex: 0,
    marginTop: -10,
    marginBottom: -16,
    marginRight: isLastItem ? 16 : -4,
    marginLeft: 16,
  }),
  newRecipientView: (theme, isAccountsAvailable) => ({
    marginTop: 15.7,
    borderBottomWidth: Platform.OS === 'web' ? 0 : 1,
    borderBottomColor: theme.colors.fillColor,
    borderTopWidth: isAccountsAvailable ? 1 : 0,
    borderTopColor: theme.colors.fillColor,
    paddingBottom: isAccountsAvailable ? 22 : Platform.OS === 'web' ? 40 : 300,
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 16,
  }),
});
